import { useEffect, useState } from 'react'
import type { MeasurementUiMessage } from '../types'

const COMPLETED_VISIBLE_MS = 1000

/**
 * Controls the messages box visibility: open for every message, and once
 * `completed` has been shown for a moment the whole box fades out. Any
 * change away from `completed` (retry, new capture) brings it back.
 */
export function useCompletedFadeOut(
  message: MeasurementUiMessage | null
): boolean {
  const [hasFadedOut, setHasFadedOut] = useState(false)

  useEffect(() => {
    if (message !== 'completed') {
      setHasFadedOut(false)
      return
    }

    const timeout = setTimeout(() => setHasFadedOut(true), COMPLETED_VISIBLE_MS)
    return () => clearTimeout(timeout)
  }, [message])

  return message !== null && !hasFadedOut
}
